import { bootstrap } from './app/bootstrap';

void bootstrap(document, window);
